import { render, staticRenderFns } from "./EditSku.vue?vue&type=template&id=c65c8e36"
import script from "./EditSku.vue?vue&type=script&lang=js"
export * from "./EditSku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports